import MModal from '../m-modal/MModal';
import Success from '@img/Success.png';
import { useDispatch, useSelector } from 'react-redux';
import { setIsSuccess } from '@reducers/notificationSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';

const MModalSuccess = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isOpen = useSelector(state => state.notification.isSuccess);
    const text = useSelector(state => state.notification.successText);
    const navigation = useSelector(state => state.notification.successNavigation);
    const buttonName = useSelector(state => state.notification.successButtonName);

    const onClose = () => {
        dispatch(setIsSuccess({ successText: '', successNavigation: navigation, successButtonName: null }));
        navigate(navigation);
    }

    return (
      <MModal
        active={isOpen}
        setActive={()=>{
            dispatch(setIsSuccess({ successText: '', successNavigation: navigation, successButtonName: null }));
        }}
        isNotification={true}
      >
          <div className={'w-[372px] flex flex-col items-center gap-[24px] justify-start'}>
              <img alt={'error'} src={Success} className={'w-fit'}/>
              <p className={'w-full text-center'}>
                  {Array.isArray(text) ? text.map(item => (
                    <p className={'whitespace-nowrap'}>
                        {item}
                    </p>
                  )) : text}
              </p>
              <div>
                  <button
                    className={'btn-primary'}
                    onClick={onClose}
                  >
                      {buttonName ? buttonName : t('general.modals.NotificationsModals.close')}
                  </button>
              </div>
          </div>
      </MModal>
    );
};

export default memo(MModalSuccess);
